var React = require('react');

function HelpV2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0001 13.3334V10.0001M10.0001 6.66675H10.0084M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001Z","stroke":"#717D77","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

HelpV2.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = HelpV2;

HelpV2.default = HelpV2;
